/**
 * Format a price/number for display using the user's locale
 * Uses Western Arabic numerals (0-9) for all locales
 * @param price - The price/number to format
 * @returns Formatted string (e.g., "1,234" for en-US, "1 234" for fr-FR)
 */
export function formatPrice(price?: number): string {
    if (price === undefined || price === null) {
        return '-'
    }
    return new Intl.NumberFormat(undefined, {
        style: 'decimal',
        minimumFractionDigits: 0,
    }).format(price)
}
